import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable } from 'immer';

interface ISubscriptionItemEntity {
	id: string;
	label: string;
	type: string;
	description: string;
	keywords: Array<AppTagItemEntity>;
	projectVersion: string;
}

const entityDefaults: ISubscriptionItemEntity = {
	id: '-1',
	label: '',
	type: '',
	description: '',
	keywords: [],
	projectVersion: '',
};

export class SubscriptionForDepotItemEntity implements ISubscriptionItemEntity {
	private [immerable] = true;

	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public type = entityDefaults.type;
	public description = entityDefaults.description;
	public keywords = entityDefaults.keywords;
	public projectVersion = entityDefaults.projectVersion;

	public static build(
		params: Partial<ISubscriptionItemEntity> = {}
	): SubscriptionForDepotItemEntity {
		const instance = new SubscriptionForDepotItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.label = params.label ?? entityDefaults.label;
		instance.type = params.type ?? entityDefaults.type;
		instance.description = params.description ?? entityDefaults.description;
		instance.keywords = params.keywords ?? entityDefaults.keywords;
		instance.projectVersion =
			params.projectVersion ?? entityDefaults.projectVersion;
		return instance;
	}
}
